import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigurationService } from '../core/configuration.service';
import { ContextService } from '../core/context.service';

@Injectable()
export class BranchService {
  private baseApiUrl: string;

  constructor(private configurationService: ConfigurationService,
     private contextService: ContextService,private httpClient: HttpClient) {
    this.baseApiUrl = this.configurationService.BaseApiUrl;
  }

  getAllBranches(forMaintenance: boolean = true): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `branch?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getBranchById(id: number, forMaintenance: boolean = true): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `branch/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  // getBranchSettings(branchId: number): Observable<any> {
  //   return this.httpClient.get(this.baseApiUrl + `branchSetting/setting/${branchId}`).pipe(
  //     map((res: Response) => res),
           

  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }
getBranchSettings(branchId: number): Observable<any> {
  return this.httpClient
    .get(this.baseApiUrl + `branchSetting/setting/${branchId}`)
    .pipe(
      map((res: any) => {
        this.contextService.setBranchData(res);
        return res;
      }),
      catchError((err: any) =>
        observableThrowError(() => err.message || 'Server error')
      )
    );
}
  createBranch(branchDetails: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'branch', branchDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateBranch(editedBranchDetails: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'branch', editedBranchDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };
    

    return this.httpClient.post(this.baseApiUrl + 'branch/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(branchNum: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'branch/authorise', branchNum).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `branch/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getAllBranchSettings( forMaintenance: boolean = true): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `branchSetting/isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getBranchesByBankId(bankId: number, forMaintenance: boolean = true): Observable<any> {
  return this.httpClient.get(this.baseApiUrl + `bank/${bankId}`).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error'))
  );
  }
  
     getallbranchdetails(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `branch/getallbranchdetails?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}
